import axios from "axios";
import toast from "react-hot-toast";
import { API_BASE_URL_V2, SERVICES_API } from "../constants";

export const apiCallV2 = (method, url, reqData, headers, params) => {
  const changeStatus = () => { };
  window.addEventListener("online", () => changeStatus());

  window.addEventListener("offline", () => changeStatus());
  return axios({
    method: method,
    url: API_BASE_URL_V2 + url,
    data: reqData,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "access-token": headers,
      "Cache-Control": "no-cache",
    },
    params: params,
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (
        typeof error != "undefined" &&
        typeof error.response != "undefined" &&
        error.response.status === 401
      ) {
        toast.error("Unauthorized error");
        // return error.response;
      } else if (
        typeof error != "undefined" &&
        typeof error.response != "undefined" &&
        error.response.status === 500
      ) {
        toast.error("Oops! Something went wrong. Report a Bug");
        // return error.response;
      } else if (
        error.response.status === 409
      ) { // EMAIL USED
        toast.error(error.response.data);
        return error.response;
      } else {
        return error.response;
      }
    });
};

export const servicesAPICall = (method, url, reqData, headers, params, cache = true) => {
  const changeStatus = () => { };
  window.addEventListener("online", () => changeStatus());

  window.addEventListener("offline", () => changeStatus());
  return axios({
    method: method,
    url: SERVICES_API + url,
    data: reqData,
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Accept": "application/json",
      "Content-Type": "application/json",
      "access-token": headers,
      "Cache-Control": "no-cache",
    },
    params: cache ? params : {
      ...params,
      t: new Date().getTime()
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      if (
        typeof error != "undefined" &&
        typeof error.response != "undefined" &&
        error.response.status === 401
      ) {
        toast.error("Unauthorized error");
        // return error.response;
      } else if (
        typeof error != "undefined" &&
        typeof error.response != "undefined" &&
        error.response.status === 500
      ) {
        toast.error("Error");
        return error.response;
      } else if (
        error.response.status === 409
      ) { // EMAIL USED
        toast.error(error.response.data);
        return error.response;
      } else {
        return error.response;
      }
    });
};